"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadImage = void 0;
var axios_1 = __importDefault(require("axios"));
function uploadImage(_a) {
    var payload = _a.payload;
    var formData = new FormData();
    formData.append('file', payload.file);
    return axios_1.default.post("https://".concat(process.env.REACT_APP_TRYBE_WP, "/wp-json/wp/v2/media"), formData, {
        headers: {
            Authorization: 'Bearer ' + payload.token,
            'Content-Type': 'multipart/form-data'
        }
    });
}
exports.uploadImage = uploadImage;
